module.exports = __webpack_public_path__ + "static/img/mobile_login.95a35124.png";